export enum REGISTER_AUTH_PROVIDER_ERRORS {
  FAILED_TO_CREATE_PROVIDER = 'Failed to create provider',
  AUTH_PROVIDER_ALREADY_EXISTS = 'Auth provider already exist',
}
